"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BatchBuffer", {
    enumerable: true,
    get: function() {
        return BatchBuffer;
    }
});
var _type_of = require("@swc/helpers/_/_type_of");
var _constants = require("./constants");
var BatchBuffer = function(batchConfigUrl, logger) {
    var isReady = false;
    var readyCallbacks = [];
    var eventsBuffer = {};
    var timeouts = {};
    var batchOptions;
    var onBatchBufferReady = function() {
        logger.info("\uD83E\uDD5E BatchBuffer - ready");
        isReady = true;
        readyCallbacks.forEach(function(readyCallback) {
            return readyCallback();
        });
        readyCallbacks = [];
    };
    var checkConfig = function(config) {
        if (config && (typeof config === "undefined" ? "undefined" : _type_of._(config)) === "object") {
            var defaultConfigCheck = {
                isValid: true,
                messages: []
            };
            var configValidation = _constants.BATCH_OPTIONS_VALIDATORS.reduce(function(acc, option) {
                var optionName = option.optionName, validator = option.validator;
                if (validator(config[optionName])) {
                    acc.isValid = acc.isValid && true;
                } else {
                    acc.isValid = false;
                    acc.messages.push('Invalid option value for "'.concat(optionName, '": ').concat(config[optionName]));
                }
                return acc;
            }, defaultConfigCheck);
            return configValidation;
        }
        return {
            isValid: false,
            messages: [
                "Invalid batching config: ".concat(JSON.stringify(config))
            ]
        };
    };
    var initBatchBuffer = function() {
        logger.info("\uD83E\uDD5E BatchBuffer - init");
        if (isReady) {
            logger.info("\uD83E\uDD5E BatchBuffer - already ready");
            return;
        }
        // For UMD lib loaded in Marco, Vasco etc, only page events are emitted.
        // To disable batching in these websites, no config URL is passed.
        if (!batchConfigUrl) {
            logger.info("\uD83E\uDD5E BatchBuffer - no batch config URL provided");
            batchOptions = {
                batchableEventList: []
            };
            onBatchBufferReady();
            return;
        }
        fetch(batchConfigUrl).then(function(res) {
            if (res.ok) {
                logger.info("\uD83E\uDD5E BatchBuffer - config retrieved");
                return res.json();
            }
            throw new Error("Could not fetch config, response status: ".concat(res.status));
        }).then(function(json) {
            var configVerification = checkConfig(json);
            if (configVerification.isValid) {
                batchOptions = json;
            } else {
                throw new Error("Invalid batching config (Reason: ".concat(configVerification.messages.join(" - "), "): ").concat(JSON.stringify(json)));
            }
        }).catch(function(err) {
            logger.info("\uD83E\uDD5E BatchBuffer - could not load / parse batching config: ".concat(err));
            // Fallback to no batching at all if the config is not valid
            batchOptions = {
                batchableEventList: []
            };
        }).finally(onBatchBufferReady);
    };
    var getBatchedEventName = function(eventName) {
        return "".concat(eventName, "_batch");
    };
    var getEventBuffer = function(eventName) {
        eventsBuffer[eventName] = eventsBuffer[eventName] || [];
        return eventsBuffer[eventName];
    };
    var resetEventBuffer = function(eventName) {
        eventsBuffer[eventName] = [];
    };
    var addEventToBuffer = function(eventName, eventData) {
        logger.info('⏳ BatchBuffer - add event "'.concat(eventName, '" to buffer'));
        var eventBuffer = getEventBuffer(eventName);
        eventBuffer.push(eventData);
    };
    var resetTimeout = function(eventName) {
        var timeout = timeouts[eventName];
        if (timeout === null) {
            return;
        }
        clearTimeout(timeout);
        timeouts[eventName] = null;
    };
    var onEventBufferFlushed = function(eventName) {
        resetEventBuffer(eventName);
        resetTimeout(eventName);
    };
    var flush = function(eventName, callback) {
        logger.info('\uD83E\uDD5E BatchBuffer - flush events for "'.concat(eventName, '"'));
        var eventBuffer = getEventBuffer(eventName);
        if (eventBuffer.length) {
            callback(getBatchedEventName(eventName), eventBuffer);
            onEventBufferFlushed(eventName);
        } else {
            logger.info("\uD83E\uDD5E BatchBuffer - buffer already empty");
        }
    };
    var checkBuffer = function(eventName, callback) {
        var eventBuffer = getEventBuffer(eventName);
        var _batchOptions_maxBufferSize = batchOptions.maxBufferSize, maxBufferSize = _batchOptions_maxBufferSize === void 0 ? 0 : _batchOptions_maxBufferSize;
        if (eventBuffer.length >= maxBufferSize) {
            logger.info('\uD83E\uDD5E BatchBuffer - max buffer size reached for "'.concat(eventName, '"'));
            flush(eventName, callback);
        }
        if (!timeouts[eventName]) {
            timeouts[eventName] = setTimeout(function() {
                logger.info('\uD83E\uDD5E BatchBuffer - flush delay reached for "'.concat(eventName, '"'));
                flush(eventName, callback);
            }, batchOptions.flushDelay);
        }
    };
    initBatchBuffer();
    return {
        addEvent: function(eventName, eventData, callback) {
            if (isReady) {
                addEventToBuffer(eventName, eventData);
                checkBuffer(eventName, callback);
            } else {
                throw new Error("BatchBuffer - `addEvent` used before it was ready.");
            }
        },
        isEventBatchable: function(eventName) {
            if (isReady) {
                var _batchOptions_batchableEventList = batchOptions.batchableEventList, batchableEventList = _batchOptions_batchableEventList === void 0 ? [] : _batchOptions_batchableEventList;
                return batchableEventList.includes(eventName);
            }
            throw new Error("BatchBuffer - `isEventBatchable` used before it was ready.");
        },
        isReady: function() {
            return isReady;
        },
        onReady: function(callback) {
            return readyCallbacks.push(callback);
        }
    };
};

//# sourceMappingURL=batchBuffer.js.map